// import { filter } from "lodash";
import { sentenceCase } from "change-case";
import { useState, forwardRef, useEffect, useRef } from "react";
import { Icon } from "@iconify/react";
import plusFill from "@iconify/icons-eva/plus-fill";
import pinFill from "@iconify/icons-eva/pin-fill";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import CheckIcon from "@mui/icons-material/Check";
import AccountTreeRoundedIcon from "@mui/icons-material/AccountTreeRounded";
import DoNotDisturbAltIcon from "@mui/icons-material/DoNotDisturbAlt";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import roundAccountTree from "@iconify/icons-ic/round-account-tree";
import FormControlLabel from "@mui/material/FormControlLabel";
import Switch from "@mui/material/Switch";
import RefreshIcon from "@mui/icons-material/Refresh";
import { Portal } from "@mui/base";
// import * as Yup from "yup";
// material
import {
  Card,
  Table,
  Stack,
  // Avatar,
  Button,
  TextField,
  TableRow,
  TableBody,
  TableCell,
  Container,
  Typography,
  TableContainer,
  TablePagination,
  Divider,
  Box,
  Chip,
  FormControl,
  InputLabel,
  Select,
  FormHelperText,
  MenuItem,
  OutlinedInput,
  Breadcrumbs,
  Link,
  IconButton,
  CircularProgress,
  createFilterOptions,
  InputAdornment,
  Tooltip,
} from "@mui/material";
// components
import Page from "../components/Page";
import Label from "../components/Label";
import Scrollbar from "../components/Scrollbar";
import CloseIcon from "@mui/icons-material/Close";
import {
  LocationListHead,
  LocationListToolbar,
  LocationMoreMenu,
} from "../components/_dashboard/location";
import { filter } from "lodash";
import { sort } from "fast-sort";
//
// import LOCATIONLIST from "../_mocks_/location";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Slide from "@mui/material/Slide";
import Pagination from "@mui/material/Pagination";
import LinearProgress from "@mui/material/LinearProgress";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import outlineImage from "@iconify/icons-ic/outline-image";
import { CallApi, BaseURL } from "../statics.js";
import TaskAltIcon from "@mui/icons-material/TaskAlt";
import PropTypes from "prop-types";
import { NumericFormat } from "react-number-format";

const NumericFormatCustom = forwardRef(function NumericFormatCustom(
  props,
  ref
) {
  const { onChange, ...other } = props;
  return (
    <NumericFormat
      {...other}
      getInputRef={ref}
      onValueChange={(values) => {
        onChange({
          target: {
            name: props.name,
            value: values.value,
          },
        });
      }}
      thousandSeparator
      valueIsNumericString
    />
  );
});

const defaultFilterOptions = createFilterOptions();

const Alert = forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

function SlideTransition(props) {
  return <Slide {...props} direction="left" />;
}
// ----------------------------------------------------------------------
function applySortFilter(array, order, orderBy, query) {
  let list = array;
  let result = [];
  if (order === "asc") {
    result = sort(list).by([
      {
        asc: (u) => {
          if (typeof u[orderBy] === "string" || u[orderBy] instanceof String)
            return u[orderBy].toLowerCase();
          else return u[orderBy];
        },
      },
      { asc: (u) => u.createdAt },
    ]);
  } else {
    result = sort(list).by([
      {
        desc: (u) => {
          if (typeof u[orderBy] === "string" || u[orderBy] instanceof String)
            return u[orderBy].toLowerCase();
          else return u[orderBy];
        },
      },
      { desc: (u) => u.createdAt },
    ]);
  }

  if (query) {
    return filter(
      result,
      (_user) => _user.title.toLowerCase().indexOf(query.toLowerCase()) !== -1
    );
  }

  return result;
}

// const TABLE_HEAD = [
//   { id: "title", label: "Title / Step Title", alignRight: false },
//   { id: "priceFormula", label: "Price Formula", alignRight: false },
//   { id: "descr", label: "Description", alignRight: false },
//   { id: "pic", label: "Picture", alignRight: false },
//   { id: "items", label: "Items", alignRight: false },
//   { id: "" },
// ];

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

export default function AdditionalItems() {
  const [page, setPage] = useState(0);
  const [totalItems, setTotalItems] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [open, setOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackType, setSnackType] = useState(false);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [buttonDisabled, setButtonDisabled] = useState(false);
  const [infoDialogOpen, setInfoDialogOpen] = useState(false);
  const [currentLocItem, setCurrentLocItem] = useState({ title: "" });
  const [actionMode, setActionMode] = useState("accepting");
  const [dialogMode, setDialogMode] = useState("add");
  const [additionalTitle, setAdditionalTitle] = useState("");
  const [additionalTitleErrorText, setAdditionalTitleErrorText] = useState("");
  const [additionalDes, setAdditionalDes] = useState("");
  const [additionalDesErrorText, setAdditionalDesErrorText] = useState("");
  const [priceFormulaValue, setPriceFormulaValue] = useState("");
  const [priceFormulaValueErrorText, setPriceFormulaValueErrorText] =
    useState("");

  const [minHeight, setMinHeight] = useState("");
  const [minHeightErrorText, setMinHeightErrorText] = useState("");
  const [maxHeight, setMaxHeight] = useState("");
  const [maxHeightErrorText, setMaxHeightErrorText] = useState("");
  const [minWidth, setMinWidth] = useState("");
  const [minWidthErrorText, setMinWidthErrorText] = useState("");
  const [maxWidth, setMaxWidth] = useState("");
  const [maxWidthErrorText, setMaxWidthErrorText] = useState("");
  const [obsoletedValue, setObsoletedValue] = useState("");
  const [obsoletedValueErrorText, setObsoletedValueErrorText] = useState("");
  // const [addAdditionalLoading, setAddAdditionalLoading] = useState(false);
  const [addDialogOpen, setAddDialogOpen] = useState(false);

  const [order, setOrder] = useState("asc");
  const [orderBy, setOrderBy] = useState("priority");
  const [filterName, setFilterName] = useState("");

  const [dataLoading, setDataLoading] = useState(true);
  const [tableData, setTableData] = useState([]);
  const [priceTypeList, setPriceTypeList] = useState([]);

  const [dimensionTypeList, setDimensionTypeList] = useState([]);
  const [dimensionTypeValue, setDimensionTypeValue] = useState("");
  const [dimensionTypeValueErrorText, setDimensionTypeValueErrorText] =
    useState("");
  const [config, setConfig] = useState(null);
  const [currentAdditionalItem, setCurrentAdditionalItem] = useState({
    id: "",
    title: "",
  });
  const [priceValue, setPriceValue] = useState("");
  const [priceValueErrorText, setPriceValueErrorText] = useState("");
  const [parnetNameList, setParnetNameList] = useState([]);

  const [stepsList, setStepsList] = useState([]);
  const [stepValue, setStepValue] = useState("");
  const [stepValueErrorText, setStepValueErrorText] = useState("");
  const [childType, setChildType] = useState("");
  const [childTypeErrorText, setChildTypeErrorText] = useState("");
  const [stepItemsList, setStepItemsList] = useState([]);
  const [selectedStepItemsValue, setSelectedStepItemsValue] = useState([]);
  const [selectedStepItemsValueErrorText, setSelectedStepItemsValueErrorText] =
    useState("");
  const [isLinkToStep, setIsLinkToStep] = useState(false);
  const [paramList, setParamList] = useState([]);
  const [paramLabelValue, setParamLabelValue] = useState("");
  const [paramDesValue, setParamDesValue] = useState("");
  const [paramLabelValueErrorText, setParamLabelValueErrorText] = useState("");
  const [paramDesValueErrorText, setParamDesValueErrorText] = useState("");
  const [picDialogOpen, setPicDialogOpen] = useState(false);
  const [currentItemsPic, setCurrentItemsPic] = useState(null);
  const [uploadList, setUploadList] = useState([]);
  const [priceType, setPriceType] = useState("");
  const [TABLE_HEAD, setTABLE_HEAD] = useState([]);
  const [priorityValue, setPriorityValue] = useState("");

  const navigate = useNavigate();

  //   let { additionalId } = useParams();
  let params = useParams();

  const getAdditionalOk = useRef(false);
  const notChangeSelectedStepItems = useRef(false);

  // const additionalTitleTextField = useRef(null);

  function getCookie(cname) {
    let name = cname + "=";
    let ca = document.cookie.split(";");
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === " ") {
        c = c.substring(1);
      }
      if (c.indexOf(name) === 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  const formatter = (value) => {
    return `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };

  useEffect(() => {
    getAllSteps();
  }, []);

  const getAllSteps = () => {
    let data = {
      username: getCookie("username"),
      token: getCookie("token"),
      page: 0,
      count: 1000,
    };
    CallApi("getAllSteps", "post", data).then((result) => {
      try {
        if (result.status === 200) {
          getAdditionalOk.current = true;
          setStepsList(result.result);
        }
      } catch (error) {
        console.log("error: ", error);
      }
    });
  };

  useEffect(() => {
    if (getAdditionalOk.current) findAdditionalItemswithPath();
  }, [stepsList]);

  const findItemswithPath = (stepId) => {
    // let parents = params["*"].split("/");
    // parents.push
    let data = {
      username: getCookie("username"),
      token: getCookie("token"),
      parentList: stepId,
      page: 0,
      count: 1000,
    };
    console.log(data);
    setButtonDisabled(true);
    CallApi("findItemswithPath", "post", data).then((result) => {
      try {
        if (result.status === 200) {
          setStepItemsList(result.result);
          notChangeSelectedStepItems.current = false;
        }
        setButtonDisabled(false);
      } catch (error) {
        console.log("error: ", error);
      }
    });
  };

  useEffect(() => {
    if (!notChangeSelectedStepItems.current) setSelectedStepItemsValue([]);
    if (stepValue) {
      findItemswithPath(stepValue);
    }
  }, [stepValue]);

  useEffect(() => {
    if (tableData.length > 0) setDataLoading(false);
  }, [tableData]);

  const findAdditionalItemswithPath = () => {
    let parents = params["*"].split("/");
    let data = {
      username: getCookie("username"),
      token: getCookie("token"),
      parentList: parents,
      page: page,
      count: rowsPerPage,
    };
    console.log(data);
    setDataLoading(true);
    CallApi("findAdditionalItemswithPath", "post", data).then((result) => {
      try {
        console.log(result);
        if (result.status === 200) {
          let res = [...result.result];
          res.forEach((element) => {
            stepsList.forEach((element1) => {
              if (element.stepId === element1._id) {
                element.stepTitle = element1.title;
              }
            });
          });

          setTableData(res);
          setParnetNameList(result.parnetNameList);
          setPriceType(result.parnetNameList[0].priceType);
          console.log(result.parnetNameList[0].priceType);
          setTABLE_HEAD(
            result.parnetNameList[0].priceType !== "none" &&
              result.parnetNameList[0].priceType !== "formulairr" &&
              result.parnetNameList[0].priceType !== "formulasm"
              ? [
                  {
                    id: "title",
                    label: "Title / Step Title",
                    alignRight: false,
                  },
                  {
                    id: "priceAmount",
                    label:
                      result.parnetNameList[0].priceType === "perm"
                        ? "IRR/m"
                        : result.parnetNameList[0].priceType === "persm"
                        ? "IRR/m\u00B2"
                        : result.parnetNameList[0].priceType === "coofsm"
                        ? "IRR*m\u00B2"
                        : "IRR",
                    alignRight: false,
                  },
                  { id: "descr", label: "Description", alignRight: false },
                  { id: "pic", label: "Picture", alignRight: false },
                  { id: "priority", label: "Priority", alignRight: false },
                  { id: "items", label: "Items", alignRight: false },
                  { id: "" },
                ]
              : result.parnetNameList[0].priceType === "formulairr"
              ? [
                  {
                    id: "title",
                    label: "Title / Step Title",
                    alignRight: false,
                  },
                  {
                    id: "priceFormula",
                    label: "IRR",
                    alignRight: false,
                  },
                  { id: "descr", label: "Description", alignRight: false },
                  { id: "pic", label: "Picture", alignRight: false },
                  { id: "priority", label: "Priority", alignRight: false },
                  { id: "items", label: "Items", alignRight: false },
                  { id: "" },
                ]
              : result.parnetNameList[0].priceType === "formulasm"
              ? [
                  {
                    id: "title",
                    label: "Title / Step Title",
                    alignRight: false,
                  },
                  {
                    id: "priceFormula",
                    label: "m\u00B2",
                    alignRight: false,
                  },
                  { id: "descr", label: "Description", alignRight: false },
                  { id: "pic", label: "Picture", alignRight: false },
                  { id: "priority", label: "Priority", alignRight: false },
                  { id: "items", label: "Items", alignRight: false },
                  { id: "" },
                ]
              : [
                  {
                    id: "title",
                    label: "Title / Step Title",
                    alignRight: false,
                  },
                  { id: "descr", label: "Description", alignRight: false },
                  { id: "pic", label: "Picture", alignRight: false },
                  { id: "priority", label: "Priority", alignRight: false },
                  { id: "items", label: "Items", alignRight: false },
                  { id: "" },
                ]
          );
          setTotalItems(result.paginateInfo.totalItems);
        }

        setDataLoading(false);
      } catch (error) {
        console.log("error: ", error);
      }
    });
  };

  const handleChangePage = (e, value) => {
    setPage(value);
  };

  useEffect(() => {
    if (tableData.length > 0) findAdditionalItemswithPath();
  }, [page]);

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const handleClickOpen = () => {
    setDialogMode("add");
    setIsLinkToStep(false);
    setStepValue("");
    setChildType(["none"]);
    setPriceValue("");
    setPriceValueErrorText("");
    setSelectedStepItemsValue([]);
    setPriorityValue("");
    setParamList([
      {
        label: "w",
        descr: "Width",
      },
      {
        label: "h",
        descr: "Height",
      },
    ]);
    setUploadList([]);
    setPriceFormulaValue("");
    setAdditionalTitle("");
    setAdditionalDes("");
    setAdditionalDesErrorText("");
    setAdditionalTitleErrorText("");
    setStepValueErrorText("");
    setChildTypeErrorText("");
    setSelectedStepItemsValueErrorText("");
    setPriceFormulaValueErrorText("");
    setAddDialogOpen(true);
  };

  const addAdditionalItem = () => {
    if (!additionalTitle) {
      setAdditionalTitleErrorText("Additional Item title cannot be empty");
      return;
    } else {
      setAdditionalTitleErrorText("");
    }

    if (isLinkToStep) {
      if (!stepValue) {
        setStepValueErrorText("Step cannot be empty");
        return;
      } else {
        setStepValueErrorText("");
      }

      if (!selectedStepItemsValue) {
        setSelectedStepItemsValueErrorText("Step item cannot be empty");
        return;
      } else {
        setSelectedStepItemsValueErrorText("");
      }
    }

    if (priceType === "formulairr" || priceType === "formulasm") {
      if (paramList.length > 0) {
        if (!priceFormulaValue) {
          setPriceFormulaValueErrorText("Price formula cannot be empty");
          return;
        } else {
          setPriceFormulaValueErrorText("");
        }
      } else {
        setPriceFormulaValueErrorText("");
      }
    }

    if (!childType) {
      setChildTypeErrorText("Child type cannot be empty");
      return;
    } else {
      setChildTypeErrorText("");
    }

    let pl = [...paramList];
    pl.forEach((element) => {
      if (element._id) delete element._id;
    });
    pl = pl.filter((item) => item.label !== "w" && item.label !== "h");

    let parents = params["*"].split("/");
    let data = {
      username: getCookie("username"),
      token: getCookie("token"),
      additionalId: parents[0],
      pic: uploadList.length > 0 ? uploadList[0].fileName : "",
      priceParams: pl,
      priceFormula: priceFormulaValue,
      priceAmount: priceValue ? priceValue : 0,
      parentList: parents,
      isLinkToStep: isLinkToStep,
      title: additionalTitle ? additionalTitle : "",
      descr: !isLinkToStep && additionalDes ? additionalDes : "",
      stepId: isLinkToStep ? stepValue[0] : "",
      activedStepItems: isLinkToStep ? selectedStepItemsValue : [],
      childType: childType[0],
      priority: priorityValue,
    };

    let apiname = "addItemToAdditional";

    if (dialogMode === "update") {
      data = {
        additionalItemId: currentAdditionalItem._id,
        username: getCookie("username"),
        token: getCookie("token"),
        pic: uploadList.length > 0 ? uploadList[0].fileName : "",
        priceParams: pl,
        priceFormula: priceFormulaValue,
        priceAmount: priceValue ? priceValue : 0,
        isLinkToStep: isLinkToStep,
        title: additionalTitle ? additionalTitle : "",
        descr: !isLinkToStep && additionalDes ? additionalDes : "",
        stepId: isLinkToStep ? stepValue[0] : "",
        activedStepItems: isLinkToStep ? selectedStepItemsValue : [],
        childType: childType[0],
        priority: priorityValue,
      };
      apiname = "updateAdditionalItems";
    }

    console.log(data);

    setButtonDisabled(true);

    CallApi(apiname, "post", data)
      .then((result) => {
        try {
          console.log(result);
          if (result.status === 200) {
            findAdditionalItemswithPath();
            setSnackType("success");

            if (apiname === "addItemToAdditional")
              setSnackbarMessage(
                "'" + additionalTitle + "' has been added successfully"
              );
            else
              setSnackbarMessage(
                "'" + additionalTitle + "' has been updated successfully"
              );

            setSnackbarOpen(true);
            setAddDialogOpen(false);
          } else {
            setSnackType("error");
            setSnackbarMessage(result.message);
            setSnackbarOpen(true);
          }
          setButtonDisabled(false);
        } catch (error) {
          console.log("error: ", error);
        }
      })
      .catch((err) => {
        setSnackType("error");
        setSnackbarMessage(err);
        setSnackbarOpen(true);
        setButtonDisabled(false);
      });
  };

  const onEditItem = (item) => {
    if (!buttonDisabled) {
      console.log("ljdfldfj", item);
      setCurrentAdditionalItem(item);
      setDialogMode("update");
      setIsLinkToStep(item.isLinkToStep);
      notChangeSelectedStepItems.current = true;
      setSelectedStepItemsValue(item.activedStepItems);
      setStepValue(item.stepId ? [item.stepId] : "");
      setChildType(item.childType ? [item.childType] : ["none"]);
      setPriorityValue(
        item.priority || item.priority === 0 ? item.priority : ""
      );

      let pp = [
        {
          label: "w",
          descr: "Width",
        },
        {
          label: "h",
          descr: "Height",
        },
      ];

      item.priceParams.forEach((element) => {
        pp.push(element);
      });

      setParamList(pp);
      setPriceFormulaValue(item.priceFormula);
      setPriceValue(
        item.priceAmount && item.priceAmount > 0 ? item.priceAmount : ""
      );
      setAdditionalTitle(item.title);
      setAdditionalDes(item.descr);
      setUploadList(
        item.pic
          ? [
              {
                file: { name: item.pic.replace("public/", "") },
                fileName: item.pic,
                status: "ok",
              },
            ]
          : []
      );
      setAdditionalDesErrorText("");
      setAdditionalTitleErrorText("");
      setStepValueErrorText("");
      setChildTypeErrorText("");
      setSelectedStepItemsValueErrorText("");
      setPriceFormulaValueErrorText("");
      setAddDialogOpen(true);
    }
  };

  const onDeleteItem = (item) => {
    if (!buttonDisabled) {
      setCurrentAdditionalItem(item);
      setDeleteDialogOpen(true);
    }
  };

  const confirmDeleteItem = () => {
    setDeleteDialogOpen(false);

    let data = {
      username: getCookie("username"),
      token: getCookie("token"),
      itemId: currentAdditionalItem._id,
    };

    // console.log(data);

    setButtonDisabled(true);
    CallApi("removeAdditionalItems", "post", data)
      .then((result) => {
        try {
          // console.log(result);
          if (result.status === 200) {
            findAdditionalItemswithPath();
          }
          setButtonDisabled(false);
        } catch (error) {
          console.log("error: ", error);
        }
      })
      .catch((err) => {
        setSnackType("error");
        setSnackbarMessage(err);
        setSnackbarOpen(true);
        setButtonDisabled(false);
      });
  };

  const getBreadcrumbsLink = (id) => {
    let l = "";
    let end = false;
    parnetNameList.forEach((element) => {
      if (!end) l += "/" + element._id;
      if (id === element._id) end = true;
    });

    return l.toString();
  };

  const handleChangeStep = (event) => {
    const {
      target: { value },
    } = event;
    setStepValue(typeof value === "string" ? value.split(",") : value);
  };
  const handleChangeStepItems = (event) => {
    const {
      target: { value },
    } = event;
    setSelectedStepItemsValue(
      typeof value === "string" ? value.split(",") : value
    );
  };
  const handleChangeChildType = (event) => {
    const {
      target: { value },
    } = event;
    setChildType(typeof value === "string" ? value.split(",") : value);
  };

  const onSelectFileComplete = (event) => {
    let files = [];

    for (let i = 0; i < event.target.files.length; i++) {
      // console.log(event.target.files[i]);
      if (
        !event.target.files[i] ||
        (event.target.files[i].type !== "image/jpg" &&
          event.target.files[i].type !== "image/webp" &&
          event.target.files[i].type !== "image/png" &&
          event.target.files[i].type !== "image/jpeg")
      ) {
        setSnackType("error");
        setSnackbarMessage("some files not valid for uploading");
        setSnackbarOpen(true);
        return;
      } else {
        files.push({ file: event.target.files[i], status: "loading" });
      }
    }

    setUploadList(files);
    document.getElementById("selectPicDialog").value = "";
  };

  useEffect(() => {
    if (uploadList.length > 0) {
      let found = false;
      uploadList.forEach((element) => {
        if (!found && element.status === "loading") {
          found = true;
          uploadFile(element.file);
        }
      });
    }
  }, [uploadList]);

  const uploadFile = (file) => {
    const data = new FormData();
    data.append("picture", file);
    data.append("username", getCookie("username"));
    data.append("token", getCookie("token"));

    console.log(file);
    CallApi("uploadPicture", "post", data, true)
      .then((result) => {
        try {
          console.log(result);
          if (result.status === 200) {
            const newState = uploadList.map((obj) => {
              if (obj.file === file) {
                return { ...obj, status: "ok", fileName: result.fileName };
              }
              return obj;
            });

            setUploadList(newState);
          } else {
            const newState = uploadList.map((obj) => {
              if (obj.file === file) {
                return { ...obj, status: "failed" };
              }
              return obj;
            });

            setUploadList(newState);
          }
        } catch (error) {
          console.log("error: ", error);
        }
      })
      .catch((err) => {
        setSnackType("error");
        setSnackbarMessage(err);
        setSnackbarOpen(true);
        const newState = uploadList.map((obj) => {
          if (obj.file === file) {
            return { ...obj, status: "failed" };
          }
          return obj;
        });

        setUploadList(newState);
      });
  };

  const onResultClick = (item) => {
    setCurrentItemsPic(item.pic);
    setPicDialogOpen(true);
  };

  const filteredDataList = applySortFilter(
    tableData,
    order,
    orderBy,
    filterName
  );

  const isUserNotFound = filteredDataList.length === 0;

  return (
    <Page title="Additional Items | Admin Panel">
      {dataLoading && (
        <LinearProgress
          color="primary"
          sx={{
            ml: -2,
            zIndex: "100000",
            width: "100%",
            position: "fixed",
            top: "0px",
          }}
        />
      )}
      {!dataLoading && (
        <Container sx={{ position: "relative" }}>
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            mb={3}
          ></Stack>
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            mb={3}
          >
            {/* <Typography variant="h4" gutterBottom>
              Additional Item of
            </Typography> */}
            <Breadcrumbs aria-label="breadcrumb" mb={2}>
              <Link
                key={-1}
                underline="hover"
                color="inherit"
                href={"/additional"}
              >
                Additional
              </Link>
              {parnetNameList.map((item, i) => {
                if (i === parnetNameList.length - 1) {
                  return (
                    <Typography key={i} color="text.primary">
                      {item.title}
                    </Typography>
                  );
                } else
                  return (
                    <Link
                      key={i}
                      underline="hover"
                      color="inherit"
                      href={"/additional" + getBreadcrumbsLink(item._id)}
                    >
                      {item.title}
                    </Link>
                  );
              })}
            </Breadcrumbs>
            <Button
              onClick={handleClickOpen}
              variant="contained"
              // component={RouterLink}
              // to="new"
              // state={{ type: "new" }}
              disabled={buttonDisabled}
              startIcon={<Icon icon={plusFill} />}
            >
              New Additional Item
            </Button>
          </Stack>

          <Card>
            {/* <LocationListToolbar
              filterName={filterName}
              searchPlaceHolder="Search title..."
              onFilterName={handleFilterByName}
            /> */}
            <Scrollbar>
              <TableContainer sx={{ minWidth: 800 }}>
                <Table>
                  <LocationListHead
                    headLabel={TABLE_HEAD}
                    rowCount={filteredDataList.length}
                    order={order}
                    orderBy={orderBy}
                    onRequestSort={handleRequestSort}
                  />
                  {!isUserNotFound && (
                    <TableBody>
                      {filteredDataList.map((row) => {
                        const {
                          _id,
                          title,
                          stepTitle,
                          priceFormula,
                          priceAmount,
                          path,
                          descr,
                          pic,
                        } = row;

                        return (
                          <TableRow hover key={_id} tabIndex={-1}>
                            <TableCell
                              component="th"
                              scope="row"
                              padding="normal"
                            >
                              <Typography variant="subtitle2" noWrap>
                                {title ? title : stepTitle}
                              </Typography>
                            </TableCell>

                            {priceType !== "none" &&
                              priceType !== "formulairr" &&
                              priceType !== "formulasm" && (
                                <TableCell>
                                  {priceAmount ? formatter(priceAmount) : "-"}
                                </TableCell>
                              )}
                            {(priceType === "formulairr" ||
                              priceType === "formulasm") && (
                              <TableCell>
                                {priceFormula ? priceFormula : "-"}
                              </TableCell>
                            )}
                            <TableCell>{descr ? descr : "-"}</TableCell>
                            <TableCell align="left">
                              {pic && (
                                <IconButton
                                  aria-label="result"
                                  onClick={() => {
                                    onResultClick(row);
                                  }}
                                >
                                  <Icon icon={outlineImage} fontSize={22} />
                                </IconButton>
                              )}
                            </TableCell>
                            <TableCell>
                              {row.priority || row.priority === 0
                                ? row.priority
                                : "-"}
                            </TableCell>
                            <TableCell align="left">
                              <Link
                                href={
                                  "/additional" +
                                  path.replaceAll(",", "/") +
                                  _id
                                }
                              >
                                <Box
                                  component={Icon}
                                  icon={roundAccountTree}
                                  sx={{
                                    color: "primary.main",
                                    width: 24,
                                    height: 24,
                                    cursor: "pointer",
                                  }}
                                />
                              </Link>
                            </TableCell>
                            <TableCell align="right">
                              <LocationMoreMenu
                                onEdit={() => onEditItem(row)}
                                onDelete={() => onDeleteItem(row)}
                              />
                            </TableCell>
                          </TableRow>
                        );
                      })}
                    </TableBody>
                  )}
                  {isUserNotFound && (
                    <TableBody>
                      <TableRow>
                        <TableCell
                          align="center"
                          colSpan={12}
                          sx={{
                            py: 3,
                            color: "text.disabled",
                            fontSize: "12px",
                          }}
                        >
                          No Data
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  )}
                </Table>
              </TableContainer>
            </Scrollbar>

            <TablePagination
              rowsPerPageOptions={[]}
              component="div"
              count={totalItems}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
            />
          </Card>
        </Container>
      )}
      <Dialog
        sx={{ p: 2, mt: 2 }}
        open={deleteDialogOpen}
        TransitionComponent={Transition}
        // keepMounted
        onClose={() => setDeleteDialogOpen(false)}
      >
        <DialogTitle>Deleting Additional</DialogTitle>
        <DialogContent sx={{ maxWidth: "400px" }}>
          <DialogContentText id="alert-dialog-description">
            {"Are you sure for deleting '" + currentAdditionalItem.title + "'?"}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={confirmDeleteItem}>Yes</Button>
          <Button onClick={() => setDeleteDialogOpen(false)} color="secondary">
            No
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        sx={{ p: 2, mt: 2 }}
        open={addDialogOpen}
        TransitionComponent={Transition}
        keepMounted
        onClose={() => {
          if (!buttonDisabled) setAddDialogOpen(false);
        }}
      >
        <DialogTitle>
          {dialogMode === "add"
            ? "Add New Additional Item"
            : "Edit Additional Item"}
        </DialogTitle>
        <DialogContent sx={{ maxWidth: "400px" }}>
          <FormControlLabel
            sx={{ mb: 1 }}
            control={
              <Switch
                disabled={buttonDisabled}
                checked={isLinkToStep}
                onChange={(e) => {
                  setIsLinkToStep(e.target.checked);
                }}
              />
            }
            label="Is Link To Step"
          />

          <TextField
            fullWidth
            sx={{ mb: 2, mt: 2 }}
            autoFocus
            type="text"
            label="Title"
            value={additionalTitle}
            onChange={(e) => setAdditionalTitle(e.target.value)}
            disabled={buttonDisabled}
            helperText={additionalTitleErrorText}
            error={additionalTitleErrorText ? true : false}
          />

          {!isLinkToStep && (
            <TextField
              fullWidth
              sx={{ mb: 2 }}
              type="text"
              label="Description"
              value={additionalDes}
              onChange={(e) => setAdditionalDes(e.target.value)}
              disabled={buttonDisabled}
              helperText={additionalDesErrorText}
              error={additionalDesErrorText ? true : false}
            />
          )}

          {isLinkToStep && (
            <FormControl
              sx={{ mb: 2, mt: 1 }}
              fullWidth
              disabled={buttonDisabled}
              error={stepValueErrorText ? true : false}
              autoFocus
            >
              <InputLabel>Step</InputLabel>
              <Select
                value={stepValue ? stepValue : ""}
                onChange={handleChangeStep}
                input={<OutlinedInput label="Step" />}
                MenuProps={MenuProps}
              >
                {stepsList.map((pt) => (
                  <MenuItem key={pt._id} value={pt._id}>
                    {pt.title}
                  </MenuItem>
                ))}
              </Select>
              <FormHelperText>{stepValueErrorText}</FormHelperText>
            </FormControl>
          )}

          {isLinkToStep && (
            <FormControl
              sx={{ mb: 2, mt: 1 }}
              fullWidth
              error={selectedStepItemsValueErrorText ? true : false}
              disabled={buttonDisabled || !stepValue}
            >
              <InputLabel>Step Items</InputLabel>
              <Select
                value={selectedStepItemsValue}
                onChange={handleChangeStepItems}
                multiple
                input={<OutlinedInput label="Step Items" />}
                MenuProps={MenuProps}
              >
                {stepItemsList.map((pt) => (
                  <MenuItem key={pt._id} value={pt._id}>
                    {pt.title}
                  </MenuItem>
                ))}
              </Select>
              <FormHelperText>{selectedStepItemsValueErrorText}</FormHelperText>
            </FormControl>
          )}

          {priceType &&
            priceType !== "none" &&
            priceType !== "formulairr" &&
            priceType !== "formulasm" && (
              <TextField
                fullWidth
                sx={{ mb: 2 }}
                autoFocus
                type="text"
                label={
                  priceType === "fixed" ||
                  priceType === "perm" ||
                  priceType === "persm"
                    ? "IRR"
                    : "Coefficient of Square of m"
                }
                value={priceValue}
                onChange={(e) => setPriceValue(e.target.value)}
                disabled={buttonDisabled}
                helperText={priceValueErrorText}
                error={priceValueErrorText ? true : false}
                name="priceTextField"
                InputProps={
                  priceType === "fixed"
                    ? { inputComponent: NumericFormatCustom }
                    : {
                        inputComponent: NumericFormatCustom,
                        endAdornment: (
                          <InputAdornment position="end">
                            {priceType === "perm"
                              ? "/m"
                              : priceType === "persm"
                              ? "/m\u00B2"
                              : priceType === "formulairr"
                              ? "IRR"
                              : priceType === "formulasm"
                              ? "m\u00B2"
                              : "*m\u00B2"}
                          </InputAdornment>
                        ),
                      }
                }
              />
            )}

          {(priceType === "formulairr" || priceType === "formulasm") && (
            <Stack
              sx={{
                p: 1,
                pt: 2,
                border: "2px solid var(--black3)",
                borderRadius: "10px",
              }}
            >
              <Stack direction="row" sx={{ gap: 1, mb: 1 }} alignItems="center">
                <TextField
                  fullWidth
                  type="text"
                  label="Param Label"
                  value={paramLabelValue}
                  onChange={(e) => setParamLabelValue(e.target.value)}
                  disabled={buttonDisabled}
                  helperText={paramLabelValueErrorText}
                  error={paramLabelValueErrorText ? true : false}
                />

                <TextField
                  fullWidth
                  type="text"
                  label="Param Description"
                  value={paramDesValue}
                  onChange={(e) => setParamDesValue(e.target.value)}
                  disabled={buttonDisabled}
                  helperText={paramDesValueErrorText}
                  error={paramDesValueErrorText ? true : false}
                />

                <IconButton
                  size="large"
                  color="primary"
                  sx={{ width: "48px", height: "48px" }}
                  onClick={() => {
                    if (
                      !paramLabelValue ||
                      paramLabelValue === "w" ||
                      paramLabelValue === "h"
                    )
                      return;
                    let found = false;
                    paramList.forEach((element) => {
                      if (element.label === paramLabelValue) found = true;
                    });

                    if (!found) {
                      let temp = [...paramList];
                      temp.push({
                        label: paramLabelValue,
                        descr: paramDesValue,
                      });
                      setParamList(temp);
                      setParamLabelValue("");
                      setParamDesValue("");
                    }
                  }}
                >
                  <TaskAltIcon />
                </IconButton>
              </Stack>

              <Box
                sx={{ display: "flex", flexDirection: "row", flexWrap: "wrap" }}
              >
                {paramList.map((item, i) => {
                  return (
                    <Chip
                      disabled={
                        buttonDisabled ||
                        item.label === "w" ||
                        item.label === "h"
                      }
                      key={i}
                      sx={{ mb: 0.5, mr: 0.5 }}
                      label={
                        item.descr ? item.label + ":" + item.descr : item.label
                      }
                      variant="outlined"
                      color="primary"
                      onDelete={
                        item.label !== "w" && item.label !== "h"
                          ? () => {
                              setParamList((chips) =>
                                chips.filter(
                                  (chip) => chip.label !== item.label
                                )
                              );
                            }
                          : null
                      }
                    />
                  );
                })}
              </Box>

              <TextField
                fullWidth
                sx={{ mt: 2 }}
                type="text"
                label="Price Formula"
                value={priceFormulaValue}
                onChange={(e) => setPriceFormulaValue(e.target.value)}
                disabled={buttonDisabled}
                helperText={priceFormulaValueErrorText}
                error={priceFormulaValueErrorText ? true : false}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      {priceType === "formulairr"
                        ? "IRR"
                        : priceType === "formulasm"
                        ? "m\u00B2"
                        : ""}
                    </InputAdornment>
                  ),
                }}
              />
            </Stack>
          )}

          <TextField
            fullWidth
            sx={{ mb: 2 }}
            autoFocus
            type="text"
            label="Priority"
            value={priorityValue}
            onChange={(e) => setPriorityValue(e.target.value)}
            disabled={buttonDisabled}
          />

          <FormControl
            sx={{ mt: 2 }}
            fullWidth
            disabled={buttonDisabled}
            error={childTypeErrorText ? true : false}
            autoFocus
          >
            <InputLabel>Child Type</InputLabel>
            <Select
              value={childType ? childType : ""}
              onChange={handleChangeChildType}
              input={<OutlinedInput label="Child Type" />}
              MenuProps={MenuProps}
            >
              <MenuItem value="none">None</MenuItem>
              <MenuItem value="singleChoice">Single Choice</MenuItem>
              <MenuItem value="parameters">Parameters</MenuItem>
            </Select>
            <FormHelperText>{childTypeErrorText}</FormHelperText>
          </FormControl>

          <Button
            fullWidth
            sx={{ mt: 2, mb: 1 }}
            // onClick={() => setDialogOpen(false)}
            variant="outlined"
            disabled={buttonDisabled}
            startIcon={<CloudUploadIcon />}
            component="label"
          >
            Upload Picture
            <input
              hidden
              accept="image/png,.jpg,.webp"
              // multiple
              type="file"
              onChange={onSelectFileComplete}
              id="selectPicDialog"
            />
          </Button>

          <Box sx={{ display: "flex", flexDirection: "row", flexWrap: "wrap" }}>
            {uploadList.map((item, i) => {
              return (
                <Chip
                  disabled={buttonDisabled}
                  key={i}
                  sx={{ mb: 0.5, mr: 0.5 }}
                  icon={
                    item.status === "ok" ? (
                      <CheckIcon />
                    ) : item.status === "failed" ? (
                      <Tooltip title="Retry">
                        <IconButton
                          aria-label="retry"
                          size="small"
                          onClick={() => {
                            const newState = uploadList.map((obj) => {
                              if (obj.file === item.file) {
                                return { ...obj, status: "loading" };
                              }
                              return obj;
                            });

                            setUploadList(newState);
                          }}
                        >
                          <RefreshIcon sx={{ fontSize: "18px" }} />
                        </IconButton>
                      </Tooltip>
                    ) : (
                      <CircularProgress color="secondary" size={20} />
                    )
                  }
                  label={item.file.name}
                  variant="outlined"
                  color={
                    item.status === "ok"
                      ? "primary"
                      : item.status === "ok"
                      ? "error"
                      : "secondary"
                  }
                  onDelete={
                    item.status === "ok"
                      ? () => {
                          setUploadList((chips) =>
                            chips.filter((chip) => chip.file !== item.file)
                          );
                        }
                      : undefined
                  }
                />
              );
            })}
          </Box>

          {buttonDisabled && (
            <LinearProgress
              color="primary"
              sx={{
                zIndex: "100000",
                width: "100%",
                position: "absolute",
                bottom: "0px",
                ml: -3,
              }}
            />
          )}
        </DialogContent>
        <DialogActions sx={{ mb: 1 }}>
          <Button
            onClick={addAdditionalItem}
            variant="contained"
            disabled={buttonDisabled}
          >
            {dialogMode === "add" ? "Add" : "Update"}
          </Button>
          <Button
            onClick={() => setAddDialogOpen(false)}
            color="secondary"
            disabled={buttonDisabled}
          >
            Cancel
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        sx={{ p: 2, mt: 2 }}
        open={picDialogOpen}
        TransitionComponent={Transition}
        onClose={() => {
          setPicDialogOpen(false);
        }}
      >
        <DialogContent>
          <img alt="" src={BaseURL + currentItemsPic} />
        </DialogContent>
      </Dialog>

      <Portal>
        <Snackbar
          open={snackbarOpen}
          onClose={() => setSnackbarOpen(false)}
          TransitionComponent={SlideTransition}
          autoHideDuration={6000}
          anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        >
          <Alert
            onClose={() => setSnackbarOpen(false)}
            severity={snackType}
            sx={{ width: "100%" }}
          >
            {snackbarMessage}
          </Alert>
        </Snackbar>
      </Portal>
    </Page>
  );
}
